export default __webpack_public_path__ + "static/media/buyers-agreement.aa695847.pdf";